import { Navigate, useOutletContext } from "react-router-dom";
import MakerStatus from "./status/MakerStatus";
import { useSelector } from "react-redux";

const MakerPending = () => {
  const ref = useOutletContext();
  const userRole = useSelector(
    (state) => state?.userAuth?.data?.role
  )?.toLowerCase();
  return userRole === "maker" ? (
    <MakerStatus anchor={ref} status="pending" title="Pending Approvals" />
  ) : (
    <Navigate to="/not-found" replace />
  );
};

export default MakerPending;
